
import { sprintf } from 'sprintf-js';
import {AccountState, SUPER_ADMIN, WLF_ADMIN, USER, DeveloperIdentityType} from "../../lib/constants";
import { DwollaPaymentIds } from "../../lib/dwolla/constants";
import { get_microdeposit_payment_id, get_microdeposit_too_many_attempts,
  funding_source_microdeposit_completed } from "../../lib/dwolla/utils";
import {is_ira_rollover, is_transfer, onboarding_start_segment} from "../../lib/onboarding-utils";
import {objToUrlParam} from "../../lib/url-util";

const dashboard_state = state => {
  return state === AccountState.LIVE
    || state === AccountState.TEST_PORTFOLIO
    || state === AccountState.TDA_PORTFOLIO
    || state === AccountState.CLOSED
    || state === AccountState.RIA_PORTFOLIO
    || state === AccountState.BROKERAGE_PORTFOLIO;
};

const dashboard_url = (
  user, all_dwolla, all_onboarding, wlf, acct_index = -1, args = {}) => {

  let micro_dep_popup = false;
  let index_key, onboarding, dwolla;

  if (user.account_type === SUPER_ADMIN) {
    return '/super-admin/css-editor';
  } else if (user.account_type === WLF_ADMIN) {
    return '/wlf-admin/clients';
  } else if (user.account_type === USER) {
    if (acct_index === -1) {
      if (user.loaded_acct_index) {
        acct_index = user.loaded_acct_index;
      } else {
        acct_index = 0;
      }
    }
    index_key = sprintf("%04d", acct_index);
    dwolla = all_dwolla[index_key];
    onboarding = all_onboarding[index_key];

    let key, acct_state;
    key = sprintf("%04d", acct_index);
    if (!user.account_state[key]) {
      acct_index = 0;
      key = sprintf("%04d", acct_index);
    }
    acct_state = user.account_state[key];

    if (args.purchase_item) {
      args.acct_index = acct_index.toString();
      const item = JSON.parse(Buffer.from(args.purchase_item, 'base64'));
      args.table = item.table;
      args.cusip = item.cusip;
      args.amt_usd = item.amt;
      delete args.purchase_item;
      return "/user/offerings" + objToUrlParam(args);
    } else if (dashboard_state(acct_state)) {
      const new_args = {
        ...args,
        acct_index: acct_index.toString(),
      }
      return "/user" + objToUrlParam(new_args);
    } else if (acct_state === AccountState.ONBOARDING) {
      if (onboarding.first_page) {
        return sprintf("/onboarding_%04d/%s", acct_index, onboarding.first_page) + objToUrlParam(args);
      }
      const segment = onboarding_start_segment(wlf, onboarding);
      return sprintf("/onboarding_%04d/%s", acct_index, segment) + objToUrlParam(args);
    } else if (acct_state === AccountState.HALF_SIGNED) {
      return sprintf("/onboarding_%04d/summary", acct_index) + objToUrlParam(args);
    } else if (acct_state === AccountState.SIGNED
      || acct_state === AccountState.SIGNED_PROXY) {
      const payment_initiated = DwollaPaymentIds.FUNDING_0 in dwolla.payments;
      const micro_dep_id = get_microdeposit_payment_id(dwolla);
      const too_many_id = get_microdeposit_too_many_attempts(dwolla);
      if (acct_index === 0) {
        micro_dep_popup = funding_source_microdeposit_completed(
          dwolla, micro_dep_id);
        if (micro_dep_popup) {
          return sprintf("/onboarding_%04d/microdeposit_verify?%s", acct_index, micro_dep_id);
        }
      }

      let page = null;

      if (micro_dep_id) {
        page = "signing_done?microdeposit_initiated=" + micro_dep_id;
      } else if (is_ira_rollover(onboarding)) {
        page = "signing_done";
      } else if (payment_initiated) {
        page = "payment_source"
      } else if (micro_dep_popup) {
        page = "microdeposit_verify?" + micro_dep_id;
      } else if (too_many_id) {
        page = "microdeposit_verify?" + too_many_id;
      } else if (!is_transfer(onboarding)) {
        page = "payment_source";
      } else if (is_transfer(onboarding)) {
        page = "signing_done";
      }

      if (page) {
        return sprintf("/onboarding_%04d/%s", acct_index, page);
      }
    }
  } else if (user.account_type === DeveloperIdentityType.UGMA_INVITEE) {
    const dwolla = all_dwolla['0000'];

    if (!dwolla) {
      return "/ugma-invite";
    }
    if (Object.keys(dwolla.funding_source).length === 0) {
      return "/ugma-invite/payment-source";
    }

    return "/ugma-invite";
  }
}


export { dashboard_url };
